import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { ClickAwayListener } from "@mui/material";
import { format } from "date-fns";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import "./MonthFilterButton.css";
import MonthPicker from "../MonthPicker";

const MonthFilterButton = ({
  value,
  setValue,
  inputRef,
  isMobile,
}: {
  value: string;
  setValue: (value: string) => void;
  inputRef?: React.MutableRefObject<any> | null;
  isMobile: boolean;
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open) {
      inputRef?.current?.blur();
    }
  }, [open, inputRef]);

  // Used to prevent ClickAwayListener from closing the popup when the button is clicked
  const [isFocused, setIsFocused] = useState(false);

  return (
    <>
      {open && (
        <div
          className="opaque"
          style={{
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "rgba(15, 44, 82,.5)",
          }}
        />
      )}
      <div style={{ position: "relative" }}>
        <Button
          id="monthFilterButton"
          ref={inputRef}
          variant={isMobile ? "text" : "outlined"}
          style={{
            minWidth: 90,
            zIndex: open ? 100 : undefined,
            backgroundColor: isMobile ? undefined : "white",
            borderRadius: 5,
            height: 32,
            paddingLeft: 8,
            // width: 90,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: isMobile
              ? undefined
              : "0px 1px 3px 0px #0000004D, 0px 4px 8px 3px #00000026",
            fontWeight: 400,
            fontSize: 14,
          }}
          onClick={() => {
            setIsFocused(false);
            setOpen(true);
            setTimeout(() => {
              setIsFocused(true);
            }, 100);
          }}
          onFocus={() => {
            if (open) return;
            setIsFocused(false);
            setOpen(true);
            setTimeout(() => {
              setIsFocused(true);
            }, 100);
          }}
        >
          <div>{format(new Date(`${value}T00:00`), "MMM yy")}</div>
          <ArrowDropDownIcon style={{ margin: 0, padding: 0 }} />
        </Button>

        {open && (
          <ClickAwayListener
            onClickAway={() => {
              if (isFocused) {
                setOpen(false);
              }
            }}
          >
            <div className="monthFilterPopup">
              <MonthPicker
                value={value}
                setValue={(v: string) => {
                  setValue(v);
                  setOpen(false);
                }}
              />
            </div>
          </ClickAwayListener>
        )}
      </div>
    </>
  );
};

export default MonthFilterButton;
